import { all, call, put, takeLatest } from 'redux-saga/effects';
import { SERVER_ERRORS } from '../../../../api/SERVER_ERRORS';
import { fetchLog, fetchServices, updateAction, fetchPersistenceFile, create, getUnresolvedEvents } from '../../../../api/services/services.api';
import { fetchPharmacies, updateSettings } from '../../../../api/pharmacy/pharmacy.api';
import notifications from '../../notification/actions';
import actions from './actions';

function* fetchLocalServices() {
    try {
        const response = yield call(fetchServices);

        if (response.services) {
            yield put({
                type: actions.FETCH_LOCAL_SERVICES_SUCCESS,
                services: response.services,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_LOCAL_SERVICES_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_LOCAL_SERVICES_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* fetchServiceLog(payload) {
    try {
        const response = yield call(fetchLog, payload.id);
        if (!response) {
            yield put({
                type: actions.DOWNLOAD_SERVICE_LOG_SUCCESS,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.DOWNLOAD_SERVICE_LOG_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.DOWNLOAD_SERVICE_LOG_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* requestLog(payload) {
    try {
        const response = yield call(updateAction, { id: payload.id, type: "SEND_LOGS" });
        if (response.success) {
            yield put({
                type: actions.FETCH_LOCAL_SERVICES,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.REQUEST_SERVICE_LOG_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.REQUEST_SERVICE_LOG_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* requestPharmacy(payload) {
    try {
        const response = yield call(fetchPharmacies, payload);
        if (response.pharmacy) {
            yield put({
                type: actions.FETCH_LOCAL_SERVICE_PHARMACY_SUCCESS,
                pharmacy: response.pharmacy,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_LOCAL_SERVICE_PHARMACY_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_LOCAL_SERVICE_PHARMACY_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* requestAllPharmacies() {
    try {
        const response = yield call(fetchPharmacies, {});
        if (response.pharmacies) {
            yield put({
                type: actions.FETCH_LOCAL_SERVICE_PHARMACIES_SUCCESS,
                pharmacies: response.pharmacies,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_LOCAL_SERVICE_PHARMACIES_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_LOCAL_SERVICE_PHARMACIES_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* updatePharmacySettings(payload) {
    try {
        const response = yield call(updateSettings, payload);
        if (response.success) {
            yield put(notifications.createNotification({
                message: "Successfully updated the settings. Local Services will be updated on their own time.",
                status: "SUCCESS",
                mainAction: actions.LOCAL_SERVICE_PHARMACY_UPDATE_SUCCESS,
            }));
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.LOCAL_SERVICE_PHARMACY_UPDATE_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.LOCAL_SERVICE_PHARMACY_UPDATE_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* fetchServiceConfig(payload) {
    try {
        const response = yield call(fetchPersistenceFile, payload.id);
        if (!response) {
            yield put({
                type: actions.DOWNLOAD_SERVICE_CONFIG_SUCCESS,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.DOWNLOAD_SERVICE_CONFIG_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.DOWNLOAD_SERVICE_CONFIG_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* createService(payload) {
    try {
        const response = yield call(create, payload.id);
        if (response.service) {
            yield put({
                type: actions.CREATE_LOCAL_SERVICE_SUCCESS,
                local_service: response.service,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.CREATE_LOCAL_SERVICE_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.CREATE_LOCAL_SERVICE_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* fetchUnresolvedEvents() {
    try {
        const response = yield call(getUnresolvedEvents, { unresolved: true });

        if (response.events) {
            yield put({
                type: actions.FETCH_UNRESOLVED_EVENTS_SUCCESS,
                events: response.events,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_UNRESOLVED_EVENTS_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_UNRESOLVED_EVENTS_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(actions.FETCH_LOCAL_SERVICES, fetchLocalServices),
        takeLatest(actions.DOWNLOAD_SERVICE_LOG, fetchServiceLog),
        takeLatest(actions.REQUEST_SERVICE_LOG, requestLog),
        takeLatest(actions.FETCH_LOCAL_SERVICE_PHARMACY, requestPharmacy),
        takeLatest(actions.LOCAL_SERVICE_PHARMACY_UPDATE, updatePharmacySettings),
        takeLatest(actions.DOWNLOAD_SERVICE_CONFIG, fetchServiceConfig),
        takeLatest(actions.FETCH_LOCAL_SERVICE_PHARMACIES, requestAllPharmacies),
        takeLatest(actions.CREATE_LOCAL_SERVICE, createService),
        takeLatest(actions.FETCH_UNRESOLVED_EVENTS, fetchUnresolvedEvents),
    ]);
}
